(function () {
  if (window.ycKartRenk) return;
  window.ycKartRenk = true;
  document.addEventListener('mouseover', function (e) {
    var k = e.target.closest && e.target.closest('.yc-kart-renk__kutu[data-img]');
    if (!k) return;
    var kart = k.closest('.card-wrapper');
    var img = kart && kart.querySelector('.card__media img');
    if (!img) return;
    if (!img.dataset.ycOrijinal) { img.dataset.ycOrijinal = img.getAttribute('src'); img.dataset.ycSrcset = img.getAttribute('srcset') || ''; }
    img.removeAttribute('srcset');
    img.src = k.dataset.img;
  });
  document.addEventListener('mouseout', function (e) {
    var liste = e.target.closest && e.target.closest('[data-yc-kart-renk]');
    if (!liste || liste.contains(e.relatedTarget)) return;
    var img = liste.closest('.card-wrapper') && liste.closest('.card-wrapper').querySelector('.card__media img');
    if (img && img.dataset.ycOrijinal) { img.src = img.dataset.ycOrijinal; if (img.dataset.ycSrcset) img.setAttribute('srcset', img.dataset.ycSrcset); }
  });
})();
